var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1800 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arm",
    transform: "translate(0,-0.324925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0H0V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0H0V-0.5z",
    transform: "rotate(-36,1,0)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arm",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arm",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arm",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arm",
    transform: "rotate(288)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1800,
    height: 900,
    fill: "#00247d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fed100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.37609,777.2654C311.44173,777.11556 497.99952,677.83404 654.14523,550.66563C858.78891,383.99945 1299.541,117.15633 1429.1161,73.7954c13.5433,-4.53215 -27.7761,23.07308 -33.14,32.01541c-138.3415,163.74043 -27.925,472.72379 144.9726,628.04829c51.99,39.7632 49.3274,41.85082 145.7074,45.7463v9l-1357.28001,-11.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.12503,795.3246c0,0 -13.16343,9.4029 -13.12495,16.4061c0.043,7.7725 14.76557,18.0468 14.76557,18.0468l1338.74505,14.7656 24.6093,-16.4062 -34.453,-21.328 -1330.54197,-11.4843z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(342.9565,112.5812) scale(45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(521.20459,267.53) scale(37.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "translate(135,321.8075) scale(45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: " translate(342.9565,652.5812) scale(52.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.67a6414c174b5a74f382a71a66aea816.svg";
export { ForwardRef as ReactComponent };